var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M8.239,16.477a8.239,8.239,0,1,1,8.239-8.239A8.248,8.248,0,0,1,8.239,16.477Zm0-14.83A6.591,6.591,0,1,0,14.83,8.239,6.6,6.6,0,0,0,8.239,1.648Zm3.3,7.415h-3.3a.825.825,0,0,1-.824-.824v-3.3a.824.824,0,1,1,1.648,0V7.415h2.472a.824.824,0,1,1,0,1.648Z",
    fill: "#6ccc5a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Time"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time",
    clipPath: "url(#clip-Time)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(3.925 4.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M8.239,16.477a8.239,8.239,0,1,1,8.239-8.239A8.248,8.248,0,0,1,8.239,16.477Zm0-14.83A6.591,6.591,0,1,0,14.83,8.239,6.6,6.6,0,0,0,8.239,1.648Zm3.3,7.415h-3.3a.825.825,0,0,1-.824-.824v-3.3a.824.824,0,1,1,1.648,0V7.415h2.472a.824.824,0,1,1,0,1.648Z",
    transform: "translate(0 0)",
    fill: "#6ccc5a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.69d8b5390acfc534ada002fa75661595.svg";
export { ForwardRef as ReactComponent };